import "./styles.scss";

import { DEV, DEBUG } from "./env";
import {
  getSpooners,
  getInvaders,
  followTheWhiteRabbit,
  thereIsNoSpoon
} from "./util/api";

import { createCanvas, setCanvasScale, setCanvasSize } from "./util/canvas";
import getStatsTracker from "./util/stats";
import createCounter from "./util/counter";
import { randomNumber } from "./util/random";
import fibonacci from "./util/fibo";

import Orbit from "./orbit";
import Moon from "./moon";

// 3rd party
import getColor from "./util/color";
import * as d3color from "d3-color";

// DEMO(NS) be here config
const INTERACTIVE = false;
const MAX_STARS = 64;
const SPEEDUP_FACTOR = 5;

const BASE_COLOR = "#000";
const BACKGROUND_COLOR = d3color.color(BASE_COLOR);

let FX_BLUR = 1;
let FX_TRAIL = 0;

const generateOrbit = (props = {}) => new Orbit({ stars: MAX_STARS, ...props });
const getMaxRadius = () => (window.innerWidth * 0.5) / 1.1;

// lol, what?
const matrix = ["🐰", "🐇", "🍰", "🥄", "🕳️"];
const wabbit = (max = matrix.length) => matrix[~~(Math.random() * max)];

const setupSpaceOrbits = () => {
  const space = [
    // new Orbit({}),
    // generateOrbit({ radius: 50, direction: 1 }),
    // generateOrbit({ radius: 100, direction: -1 }),
    // generateOrbit({ radius: 200 }),
    // generateOrbit({ radius: 400, direction: -1 }),
    // generateOrbit({ radius: 400, direction: -2 }),
    // generateOrbit({ radius: 400, direction: 2 }),
    // generateOrbit({ radius: randomNumber(400, getMaxRadius()) })
  ];

  // #fibonnaci
  for (let x = 2; x < 9; x++) {
    const fibo = fibonacci(x);

    space.push(
      generateOrbit({
        radius: fibonacci(x) * 50,
        // radius: randomNumber(fibonacci(x) * 50, getMaxRadius()),
        // radius: randomNumber(fibo * 50 - 3, fibo * 50 + 3),
        direction: x % 2 ? -1 : fibo
      })
    );
  }

  // const orb = generateOrbit({
  //   radius: fibonacci(2) * 50,
  //   direction: fibonacci(4)
  // });
  // orb.setColor("red");
  // space.push(orb);

  space.push(
    generateOrbit({
      radius: fibonacci(2) * 50,
      direction: -fibonacci(3)
    })
  );

  space.push(
    generateOrbit({
      radius: fibonacci(4) * 50,
      direction: -fibonacci(4)
    })
  );

  return space;
};

const doIt = async () => {
  const root = document.getElementById("app");
  const emo = document.getElementById("emo");
  const emojif = Moon("emo");

  const canvas = createCanvas(root);
  const ctx = canvas.getContext("2d");
  const trackFPS = getStatsTracker();
  let RUNNING = false;

  // alien trackers!
  const invaders = createCounter("invaders", 0);
  const spooners = createCounter("spooners", 0);

  if (invaders.error || spooners.error)
    throw new Error(invaders.error || spooners.error);

  const setInvaders = value => invaders.update(value);
  const setSpooners = value => spooners.update(value);

  // #TEST
  // setInvaders(177)
  // setSpooners(666)

  // const gradient = ctx.createLinearGradient(0, 0, 170, 0);
  const gradient = ctx.createRadialGradient(0, 0, 100, 0, 0, getMaxRadius());
  // gradient.addColorStop("0", "cyan");
  // gradient.addColorStop("0.5", "blue");
  // gradient.addColorStop("0.9", "magenta");
  // gradient.addColorStop("1.0", "red");
  gradient.addColorStop("0", getColor());
  gradient.addColorStop("0.5", getColor());
  gradient.addColorStop("0.7", getColor());
  gradient.addColorStop("1.0", getColor());

  // space helpers
  const renderOrbit = orbit => {
    const { particles } = orbit;

    if (orbit.renderNo < particles.length) {
      orbit.renderNo++;
    }

    ctx.save();

    if (FX_BLUR) {
      ctx.shadowBlur = 5;
      ctx.shadowColor = "#0f0"; //`rgba(100, 255, 255, 1)`;
    }

    orbit.render(ctx);

    ctx.restore();

    // if (DEBUG) {
    //   orbit.particles.forEach(particle => {
    //     // ctx.save();
    //     ctx.beginPath();
    //     ctx.lineWidth = 0.09;
    //     ctx.strokeStyle = `rgba(255, 255, 255, .3)`; //"white";

    //     ctx.moveTo(0, 0);
    //     ctx.lineTo(particle.x, particle.y);
    //     ctx.stroke();
    //     // ctx.restore();
    //   });
    // }
    // orbit.render(ctx);
  };

  const animate = () => {
    trackFPS();
    requestAnimationFrame(animate);
    // setTimeout(() => { render(orbit); }, 200);

    const { width, height } = canvas;

    // trail ?
    if (FX_TRAIL) {
      const opa = (randomNumber(10, 20) * 0.005).toFixed(3);
      // ctx.fillStyle = `rgba(0, 0, 0, ${opa})`;
      ctx.fillStyle = BACKGROUND_COLOR.copy({ opacity: opa }).toString();

      ctx.fillRect(-width, -height, width * 2, height * 2);
    } else {
      // ctx.clearRect(-width, -height, width * 2, height * 2);

      ctx.fillStyle = BACKGROUND_COLOR.toString();
      ctx.fillRect(-width, -height, width * 2, height * 2);
    }

    space.forEach(orbit => renderOrbit(orbit));
  };

  // create/setup teh SPACE!
  const space = [...setupSpaceOrbits()];
  // space.push(generateOrbit({ radius: randomNumber(400, getMaxRadius()) }));
  // console.log("space @ ");
  // console.table(space);

  // #TEST
  const setParticlesColor = newColor => {
    space.forEach(orbit => {
      orbit.setColor(newColor);
    });
  };

  // setParticlesColor(gradient);

  // magic
  const spaceAndBeyond = () => {
    console.log("🥮 for you!");
    // it's not a bug, it's a random feature
    space.forEach(orbit => {
      orbit.particles.forEach(particle => {
        particle.move += particle.move / SPEEDUP_FACTOR;
      });
    });
  };

  // resize if needed..
  window.addEventListener("resize", () => {
    setCanvasSize(canvas);
    setCanvasScale(canvas, ctx);
  });

  // MOUSE handlers
  emo.addEventListener("mouseenter", _ => {
    FX_BLUR = 0;
    FX_TRAIL = 1;
    ~~(Math.random() * 2) && setParticlesColor(gradient);
  });

  emo.addEventListener("mouseout", _ => {
    FX_TRAIL = 0;
    // setParticlesColor("white");
    if (~~(Math.random() * 2)) {
      FX_BLUR = 1;
      setParticlesColor("white");
    }
  });

  emo.addEventListener("click", async _ => {
    if (INTERACTIVE) {
      emojif.run();
      if (!RUNNING) {
        RUNNING = true;
        animate();
      }
    } else {
      emojif.app.style.opacity = 1;
      emojif.render(wabbit());
    }

    spaceAndBeyond();

    try {
      setSpooners(await thereIsNoSpoon());
      setInvaders(await getInvaders());
    } catch (err) {
      console.warn("oops :( @", err);
    }
  });

  // do it!
  // animate();
  if (INTERACTIVE) {
    // emojif.render(wabbit());
  } else {
    emojif.app.style.opacity = 0.1; // easter egg opacity ?
    emojif.render(wabbit());

    animate();
  }

  // get invadors!
  setInvaders(await followTheWhiteRabbit());
  setSpooners(await getSpooners());
};

doIt();
